class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onPointerDown = this.handlePointerDown.bind(this);
    this.onClickCapture = this.handleClickCapture.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.addEventListener('pointerdown', this.onPointerDown, true);
    document.addEventListener('click', this.onClickCapture, true);
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.removeDocumentListeners();
    this.pressedControl = null;
    // iOS does not focus tapped buttons, so the popup's own focus may be the only one left; drop it, or
    // the sticky header (kept on screen while it holds :focus-visible) could not hide
    if (this.notification.contains(document.activeElement)) document.activeElement.blur();

    removeTrapFocus(this.activeElement);
  }

  removeDocumentListeners() {
    document.removeEventListener('pointerdown', this.onPointerDown, true);
    document.removeEventListener('click', this.onClickCapture, true);
    document.body.removeEventListener('click', this.onBodyClick);
  }

  // a header re-render in the theme editor while the popup is open must not leave its listeners behind
  disconnectedCallback() {
    this.removeDocumentListeners();
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  // OverDMA: a tap outside the open panel only closes it. When that tap lands on a control (Add to cart,
  // Buy now, a link), the control is not pressed as well; a tap on empty space passes through as before.
  // Only presses that start while the panel is open count, so a press begun before it appeared still works.
  handlePointerDown(evt) {
    const target = evt.target;
    this.pressedControl = target.closest('cart-notification')
      ? null
      : target.closest('a[href], button, input, select, textarea, label, summary, [role="button"], [tabindex]:not([tabindex="-1"])');
  }

  handleClickCapture(evt) {
    const control = this.pressedControl;
    this.pressedControl = null;
    if (!control || !control.contains(evt.target)) return;
    evt.preventDefault();
    evt.stopPropagation();
    this.handleBodyClick(evt);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
